import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Ana Sayfa", href: "#hero" },
  { label: "Neden Kazakistan", href: "#neden" },
  { label: "Bölümler", href: "#bolumler" },
  { label: "Üniversiteler", href: "#universiteler" },
  { label: "Nasıl İşliyor", href: "#nasil" },
  { label: "Kayıt", href: "#belgeler" },
  { label: "SSS", href: "#sss" },
  { label: "İletişim", href: "#iletisim" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#f7f9fa]/80 backdrop-blur-xl border-b border-black/5" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <a href="#hero" data-testid="nav-logo" className="flex items-center group">
          <img
            src="/logo-full.png"
            alt="Study in Kazakhstan"
            className="h-14 sm:h-16 w-auto object-contain group-hover:scale-105 transition-transform"
          />
        </a>

        <div className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm font-medium text-[#1a1a1a]/70 hover:text-[#1B19A8] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#basvuru"
            data-testid="nav-cta"
            className="hidden sm:inline-flex items-center rounded-full bg-[#FFE500] px-5 py-2.5 text-sm font-semibold text-[#1a1a1a] shadow-[0_8px_24px_rgba(245,158,11,0.35)] hover:bg-[#EACE00] active:scale-[0.98] transition-[background-color,transform]"
          >
            Ücretsiz Danışmanlık
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden grid place-items-center w-10 h-10 rounded-xl border border-black/10 text-[#1a1a1a]"
            aria-label="Menü"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden overflow-hidden bg-[#f7f9fa]/95 backdrop-blur-xl border-b border-black/5"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-4 flex flex-col gap-1">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="py-3 text-base font-medium text-[#1a1a1a]/80 border-b border-black/5 last:border-0"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#basvuru"
                onClick={() => setOpen(false)}
                className="mt-3 text-center rounded-full bg-[#FFE500] px-5 py-3 font-semibold text-[#1a1a1a]"
              >
                Ücretsiz Danışmanlık Al
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
